export default __webpack_public_path__ + "static/media/teachers_office.4653862e.jpeg";